import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "./utils/authInterceptor";
import "./input.css";
import VueApexCharts from "vue3-apexcharts";
import "monaco-editor/min/vs/editor/editor.main.css";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import "katex/dist/katex.min.css";
import { VueDatePicker } from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { resetThemeColor } from "./utils/themeColor";

const app = createApp(App);

const root = document.documentElement;

resetThemeColor();
root.style.setProperty("--leftNavBg", process.env.VUE_APP_LEFT_NAV_BG);
root.style.setProperty("--hoverColor", process.env.VUE_APP_HOVER_COLOR);
root.style.setProperty("--whiteBG", process.env.VUE_APP_WHITE_BG);
root.style.setProperty("--grayBG", process.env.VUE_APP_GRAY_BG);
root.style.setProperty("--graySecondaryBg", process.env.VUE_APP_GRAY_SECONDARY);
root.style.setProperty("--grayTertiaryBg", process.env.VUE_APP_GRAY_TERTIARY);
root.style.setProperty("--brand-rgb", "0, 39, 82");

// plugins
app.use(VueApexCharts);
app.component("VueDatePicker", VueDatePicker);

app.use(store);
app.use(router);

app.mount("#app");

if (process.env.NODE_ENV !== "production") {
  window.$store = store;
}
